import {catchError, map} from 'rxjs/operators';
import {throwError} from 'rxjs';
import {Injectable, inject, DestroyRef} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {RestServiceAbstract} from "../../../core/base/rest.service.abstract";
import {ResponseModel} from "../../../core/base/response.model";

@Injectable({
  providedIn: 'root',
})

export class AdsRestService extends RestServiceAbstract {
  private readonly destroyRef = inject(DestroyRef);

  getCurrentAds(idf: string) {
    return this.postPhx('/cms/ads', {idf: idf, company: 'HAGEDA'}).pipe(
      takeUntilDestroyed(this.destroyRef),
      map((data: Object) => new ResponseModel(data)),
      catchError((err: any) => throwError(() => err))
    );
  }
}
